<template>
    <div class="stat-hero-card">
        <img :src="imageUrl" :alt="imageAlt" class="stat-hero-card__image" />
        <h1 class="stat-hero-card__title" v-html="title"></h1>
    </div>
</template>

<script>
    export default {
        name: 'StatHeroCard',

        props: {
            title:    { type: String, required: true },
            imageUrl: { type: String, required: true },
            imageAlt: { type: String, required: true },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .stat-hero-card {
        display:         flex;
        flex-direction:  column;
        justify-content: center;
        align-items:     center;

        height:          100%;

        padding:         3rem;

        border:          0.1rem solid $gray-300;
        background:      $white;

        color:           $gray-500;

        @include media-breakpoint-down (md) {
            flex-direction: column-reverse;
        }

        &__title {
            font-size:   4rem;
            text-align:  center;
            font-weight: normal;

            @include media-breakpoint-down (md) {
                font-size: 2rem;
            }
        }

        &__image {
            max-width: 100%;
        }
    }
</style>
